import PizZip from 'pizzip'
import docxtemplater from 'docxtemplater'
import JSZipUtils from 'jszip-utils'
import {saveAs} from 'file-saver'
/**
 * 将base64格式的数据转为ArrayBuffer
 * @param {Object} dataURL base64格式的数据
 */
function base64DataURLToArrayBuffer(dataURL) {
	const base64Regex = /^data:image\/(png|jpg|jpeg|svg|svg\+xml);base64,/;
	if (!base64Regex.test(dataURL)) {
		return false;
	}
	const stringBase64 = dataURL.replace(base64Regex, "");
	let binaryString;
	if (typeof window !== "undefined") {
		binaryString = window.atob(stringBase64);
	} else {
		binaryString = new Buffer(stringBase64, "base64").toString("binary");
	}
	const len = binaryString.length;
	const bytes = new Uint8Array(len);
	for (let i = 0; i < len; i++) {
		const ascii = binaryString.charCodeAt(i);
		bytes[i] = ascii;
	}
	return bytes.buffer;
}
/**
 * 导出word
 * @param {Object} tempDocxPath 模板路径
 * @param {Object} wordData 导出数据
 * @param {Object} fileName 导出文件名
 * @param {Object} imgSize 图片尺寸
 * @param {Object} isDow 是否下载
 */
export const exportWord = async (tempDocxPath, wordData, fileName,imgSize, isDow = false) => {
	var ImageModule = require('docxtemplater-image-module-free');
	const expressions = require("angular-expressions");
	return new Promise(resolve => {
		JSZipUtils.getBinaryContent(tempDocxPath, function(error, content) {
			if (error) {
				throw error;
			}
			expressions.filters.size = function(input, width, height) {
				return {
					data: input,
					size: [width, height],
				};
			};
			//function angularParser(tag) {
			//	const expr = expressions.compile(tag.replace(/'/g, "'"));
			//	return {
			//		get(scope) {
			//			return expr(scope);
			//		},
			//	};
			//}
			// 图片处理
			let opts = {}
			opts = {
				//图像是否居中
				centered: true
			};
			opts.getImage = (chartId) => {
				//console.log(chartId);//base64数据
				//将base64的数据转为ArrayBuffer
				return base64DataURLToArrayBuffer(chartId);
			}
			opts.getSize = function(img, tagValue, tagName) {
				//自定义图像大小
				if( tagName in imgSize){
					return imgSize[tagName];
				}else{
					return [300, 300];
				}
			}
			let zip = new PizZip(content);
			let doc = new docxtemplater();
			doc.attachModule(new ImageModule(opts));
			doc.loadZip(zip);
			doc.setData(wordData);
			try {
				doc.render();
			} catch (error) {
				let e = {
					message: error.message,
					name: error.name,
					stack: error.stack,
					properties: error.properties
				};
				console.log(JSON.stringify({
					error: e
				}));
				throw error;
			}
			let out = doc.getZip().generate({
				type: "blob",
				mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
			});
			if (isDow) {
				saveAs(out, fileName);
				resolve()
			} else {
				const file = new File([out], fileName, { type: 'text/plain' });
				resolve(file)
			}
		});
	})
}
/**
 * 将图片的url路径转为base64路径
 * @param {Object} imgUrl 图片路径
 */
export function getBase64Sync(imgUrl) {
	return new Promise(function(resolve) {
		let image = new Image();
		image.src = imgUrl;
		image.setAttribute("crossOrigin", '*');  // 图片支持跨域
		image.onload = function() {
			let canvas = document.createElement("canvas");
			canvas.width = image.width;
			canvas.height = image.height;
			let context = canvas.getContext("2d");
			context.drawImage(image, 0, 0, image.width, image.height);
			//图片后缀名
			let ext = image.src.substring(image.src.lastIndexOf(".") + 1).toLowerCase();
			//图片质量
			let quality = 0.8;
			//转成base64
			let dataurl = canvas.toDataURL("image/" + ext, quality);
			//返回
			resolve(dataurl);
		};
	})
}
